// Pure status maths for FormShell. The loan form's definition (Add_Loan
// getSectionStatus / overallProgress) is the one definition — see HLD §4.

export const SECTION_STATE = {
  LOCKED: "locked",
  ERROR: "error",
  COMPLETE: "complete",
  PARTIAL: "partial",
  OPTIONAL: "optional",
};

/**
 * Badge / quick-nav state for one section. Order is load-bearing: it is the
 * loan badge priority. `optionalCountsAsComplete` defaults to true because the
 * loan form shows an all-optional section as "Complete" (LLD §3.2 trap) — do
 * not simplify it away.
 */
export function getSectionState(s, { optionalCountsAsComplete = true } = {}) {
  if (s.locked) return SECTION_STATE.LOCKED;
  if (s.errorCount > 0) return SECTION_STATE.ERROR;
  if (
    s.filledRequired === s.requiredTotal &&
    (s.requiredTotal > 0 || optionalCountsAsComplete)
  ) {
    return SECTION_STATE.COMPLETE;
  }
  if (s.requiredTotal > 0) return SECTION_STATE.PARTIAL;
  return SECTION_STATE.OPTIONAL;
}

/** @returns {{ filled: number, total: number, errors: number, percent: number }} */
export function summariseSections(sections) {
  const totals = (sections || []).reduce(
    (acc, s) => {
      acc.filled += s.filledRequired;
      acc.total += s.requiredTotal;
      acc.errors += s.errorCount;
      return acc;
    },
    { filled: 0, total: 0, errors: 0 }
  );
  return {
    ...totals,
    percent:
      totals.total > 0 ? Math.round((totals.filled / totals.total) * 100) : 0,
  };
}

/** Count helper for the checks-based forms (-003 / -004). */
export function sectionStatusFromChecks(
  { id, title, icon },
  checks,
  formErrors
) {
  const mine = checks.filter((c) => c.sectionId === id);
  return {
    id,
    title,
    icon,
    requiredTotal: mine.length,
    filledRequired: mine.filter((c) => c.filled).length,
    errorCount: Object.keys(formErrors || {}).filter((k) =>
      mine.some((c) => c.fieldId === k)
    ).length,
  };
}
